import React, { useState } from "react";
import styled from "styled-components";
import { useAppContext } from "../../context/useAppContext";
import { priceSymbol } from "../../utils/symbol";
import { useRequest } from "../../hooks/useRequest";
import { useNavigate } from "react-router-dom";

const CheckoutOrderSummaryStyle = styled.div`
  padding: 30px;
  border-radius: 11.25px;
  border: 0.75px solid #d9d9d9;
  background: #fff;
  .checkout__order__summary__item {
    display: flex;
    justify-content: space-between;
    gap: 15px;
    padding-top: 20px;
    border-top: 0.75px solid rgba(48, 48, 48, 0.25);
    margin-top: 20px;
    &:first-child {
      margin-top: 35px;
      border-top: 0px;
      padding-top: 0px;
    }
  }
  .checkout__order__summary__title {
    color: #303030;
    font-size: 18px;
    font-weight: 600;
    line-height: 22.5px;
  }
  .checkout__order__summary__item__title {
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    color: #303030;
    font-size: 15px;
    font-weight: 400;
    line-height: 22.5px;
    text-transform: capitalize;
    overflow: hidden;
    flex: 1;
    display: flex;
    align-items: center;
    gap: 8px;
    &.flex {
      display: flex;
      gap: 4px;
    }
  }
  .quantity__badge {
    font-size: 12px;
    font-weight: 600;
    color: #666;
    background-color: #f5f5f5;
    padding: 2px 6px;
    border-radius: 4px;
    white-space: nowrap;
    flex-shrink: 0;
  }
  .checkout__order__summary__item__quantity,
  .checkout__order__summary__item__totals {
    color: #303030;
    font-size: 15px;
    font-weight: 700;
    line-height: 22.5px;
    flex: 0 0 80px;
    text-align: right;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .checkout__order__summary__item__quantity {
    flex: 0 0 30px;
    text-align: center;
  }
  .checkout__order__summary__handler {
    margin-top: 10px;
    padding-top: 15px;
    border-top: 0.75px solid rgba(48, 48, 48, 0.25);
    margin-top: 35px;
    .checkout__order__summary__subtotals {
      display: flex;
      justify-content: space-between;
      margin-bottom: 10px;
      .checkout__items__total__title {
        color: #303030;
        font-size: 15px;
        line-height: 22px;
        font-weight: 400;
        &.bold {
          font-weight: 700;
        }
      }
    }
    .checkout__now__button {
      color: #fff;
      text-align: center;
      font-size: 15px;
      font-weight: 700;
      line-height: 23px;
      border-radius: 5px;
      width: 100%;
      height: 50px;
      background: #ae0000;
      margin-top: 20px;
      &:disabled {
        background: #a7a7a7;
      }
    }
  }
  .variation-item {
    padding-top: 8px !important;
    padding-bottom: 8px !important;
    margin-top: 8px !important;
    border-top: none !important;
    padding-left: 20px;
    background: #f9f9f9;
    
    .checkout__order__summary__item__title {
      font-size: 13px;
      color: #666;
    }
    
    .variation-label {
      font-weight: 500;
    }
  }
  @media (max-width: 768px) {
    padding: 15px;
    .checkout__order__summary__title {
      font-size: 16px;
    }
    .checkout__order__summary__item__list {
      padding-top: 8px;
    }
    .checkout__order__summary__item {
      margin-top: 12px;
      gap: 24px;
    }
    .checkout__order__summary__item__title {
      font-size: 14px;
    }
    .checkout__order__summary__item__quantity,
    .checkout__order__summary__item__totals {
      font-size: 14px;
      font-weight: 600;
    }
    .checkout__order__summary__handler .checkout__now__button {
      width: 100%;
      font-size: 14px;
      height: 42px;
    }
    .variation-item {
      padding-left: 15px;
      
      .checkout__order__summary__item__title {
        font-size: 12px;
      }
    }
  }
`;

const CheckoutOrderSummary = ({
  orderSummaryData,
  handleOrderNow,
  checkoutAddress,
  isCheckoutDisabled,
  caRateService,
  dt,
  billingType
}) => {
  const { checkoutCartData } = useAppContext();
  const navigate = useNavigate()
  
  const { setCartItemNumber } = useAppContext();



  const [handleRequest] = useRequest()

  const deliveryPartner = ['inhouse', 'internal shipping', 'Canada Post', 'Fedex'];
  const onlinePayPartner = ['Canada Post', 'Fedex'];
  const [isLoading,setIsLoading] = useState(false)

  const handleOrderDraftNow = async () => {
    try {
      setIsLoading(true)
      const path = `/order/create/draft`;
      const response = await handleRequest({
        path,
        method: "POST",
        body: JSON.stringify({
          cartId: checkoutCartData._id,
          billingAddress: checkoutAddress?.billing,
          shippingAddress: checkoutAddress?.shipping,
          deliveryPartner: deliveryPartner[dt],
          // appliedCoupon,
          usedReward: orderSummaryData?.usedReward || 0,
          billingPhone: checkoutAddress?.billingPhone,
          shippingPhone: checkoutAddress?.shippingPhone,
        }),
      });

      if(response.success){
        setCartItemNumber(0);
      }

      
      setIsLoading(false)

      navigate('/thank-you')
      // toast.success("Success");
    } catch (error) {
      console.log(error);
      setIsLoading(false)
    }
  };

  const parseVariations = (variationString) => {
    try {
      return JSON.parse(variationString) || [];
    } catch (error) {
      console.error("Error parsing variations:", error);
      return [];
    }
  };

  return (
    <CheckoutOrderSummaryStyle>
      <h3 className="checkout__order__summary__title">Order Summary</h3>
      <div className="checkout__order__summary__item__list">
        {checkoutCartData?.items?.length &&
          checkoutCartData?.items?.map((item) => {
            if (item?.quantity > 0) {
              const variations = parseVariations(item.variation);
              const basePrice = item?.product?.discount_required
                ? item?.product?.discountedPrice
                : item?.product?.price;

              return (
                <div key={item?._id}>
                  <div className="checkout__order__summary__item">
                    <p className="checkout__order__summary__item__title">
                      <span className="quantity__badge">x {item?.quantity}</span>
                      {item?.product?.name}
                    </p>
                    <h4 className="checkout__order__summary__item__totals">
                      {priceSymbol}
                      {Number(basePrice * item?.quantity)?.toFixed(2)}
                    </h4>
                  </div>
                  {/* Display variations if they exist */}
                  {variations.map((variation, index) => (
                    <div key={index} className="checkout__order__summary__item variation-item">
                      <p className="checkout__order__summary__item__title flex">
                        <span className="quantity__badge">x {item?.quantity}</span>
                        <span className="variation-label">{variation.name}:</span>
                        <span>{variation.value}</span>
                      </p>
                      <h4 className="checkout__order__summary__item__totals">
                        {priceSymbol}
                        {Number(variation?.price || 0 * item?.quantity)?.toFixed(2)}
                      </h4>
                    </div>
                  ))}
                </div>
              );
            }
            return null;
          })}
      </div>
      <div className="checkout__order__summary__handler">
        <div className="checkout__order__summary__subtotals">
          <div className="checkout__items__total__title">Subtotal</div>
          <div className="checkout__order__summary__item__totals">
            {priceSymbol}
            {orderSummaryData?.subtotal?.toFixed(2)}
          </div>
        </div>
        {orderSummaryData?.discountAmount > 0 && (
          <div className="checkout__order__summary__subtotals">
            <div className="checkout__items__total__title">
              Coupon Discount
              {/* <span style={{ fontSize: "10px", color: "#4caf50" }}>
                {checkoutCartData?.coupon?.couponCode} )
              </span> */}
            </div>
            <div
              className="checkout__order__summary__item__totals"
              style={{ color: "rgb(76, 175, 80)" }}
            >
              {priceSymbol}
              {orderSummaryData?.discountAmount?.toFixed(2)}
            </div>
          </div>
        )}

        {billingType !== 'pickup' && 
        <div className="checkout__order__summary__subtotals">
          <div className="checkout__items__total__title">Shipping Fee</div>
          <div className="checkout__order__summary__item__totals">
            {priceSymbol}
            {orderSummaryData?.shippingCharges?.toFixed(2)}
          </div>
        </div>
}
        {/* <i style={{ fontSize: "12px", color: "#211f1f", fontWeight: 500, marginBottom: 14, display: 'block' }}>
          ( Shipping Fee will be confirmed within 30 minutes after Order Confirmation )
        </i> */}
        <div className="checkout__order__summary__subtotals">
          <div className="checkout__items__total__title">GST Tax</div>
          <div className="checkout__order__summary__item__totals">
            {priceSymbol}
            {orderSummaryData?.gst?.toFixed(2)}
            {/* {orderSummaryData?.taxAmount} */}
          </div>
        </div>
        <div className="checkout__order__summary__subtotals">
          <div className="checkout__items__total__title">PST Tax</div>
          <div className="checkout__order__summary__item__totals">
            {priceSymbol}
            {orderSummaryData?.pst?.toFixed(2)}
            {/* {orderSummaryData?.taxAmount} */}
          </div>
        </div>
        {orderSummaryData?.usedReward > 0 && (
          <div className="checkout__order__summary__subtotals">
            <div className="checkout__items__total__title">IB Rewards</div>
            <div className="checkout__order__summary__item__totals">
              - {priceSymbol}
              {orderSummaryData?.usedReward?.toFixed(2)}
            </div>
          </div>
        )}
        <div className="checkout__order__summary__subtotals">
          <div className="checkout__items__total__title bold">Total</div>
          <div className="checkout__order__summary__item__totals">
            {priceSymbol}
            {orderSummaryData?.totalAmount?.toFixed(2)}
          </div>
        </div>


        {
          (billingType === 'pickup') || (onlinePayPartner.indexOf(deliveryPartner[dt]) >= 0) ? (
            <button
              className="checkout__now__button"
              disabled={isCheckoutDisabled}
              onClick={handleOrderNow}
            >
              Order Now
            </button>
          ) :
            (
              <button
                className="checkout__now__button"
                disabled={isCheckoutDisabled || isLoading}
                onClick={handleOrderDraftNow}
              >
                Order Draft
              </button>
            )
        }
      </div>
      {billingType !== 'pickup' && deliveryPartner[dt] !== 'Canada Post' && deliveryPartner[dt] !== 'Fedex' && <strong style={{ fontSize: "14px", color: "#211f1f", fontWeight: 700, marginTop: 14, display: 'block' }}>
        Remark* : Your order will be placed in order drafts, where you can pay and finalize it after the shipping costs have been updated.
      </strong>}
    </CheckoutOrderSummaryStyle>
  );
};

export default CheckoutOrderSummary;
